import ProductOrder from '@/shared/types/productOrder.type';

const transform = (list: Record<string, unknown>[]): ProductOrder[] => {
  return list.map((item) => ({
    id: item.variant_id || item.product_id,
    name: item.variant_name || item.product_name,
    price: item.value,
    product_qty: '1',
    sku: item.sku,
    product_id: item.product_id,
    variant_id: item.variant_id,
    product_name: item.product_name,
    variant_name: item.variant_name,
    in_account_id: item.in_account_id,
    in_order_id: item.in_order_id,
    in_tenant_id: item.in_tenant_id,
    post_tax_price: item.post_tax_price,
    pre_tax_price: item.pre_tax_price,
    product_description: item.product_description,
    tax_multiplier: item.tax_multiplier,
    value: item.value,
  })) as ProductOrder[];
};

type Args = {
  products: Record<string, unknown>[];
  variants: Record<string, unknown>[];
};

const transformVariantsAndProducts = ({ products, variants }: Args) => {
  try {
    // Remove variants which already exist in products
    const f_variants = variants.filter(
      (itemVariant) =>
        !products.some(
          (itemProduct) => itemProduct.product_id === itemVariant.product_id,
        ),
    );

    // Remove empty variants from the products
    const f_products = products.map((itemProduct) => {
      const variants = itemProduct.variants as Record<string, unknown>[];
      const filteredVariants = variants.filter(
        (itemVariant) =>
          typeof itemVariant.variant_name === 'string' &&
          itemVariant.variant_name !== '',
      );

      return { ...itemProduct, variants: filteredVariants };
    });

    // Get inner products variants of filtered products
    const productsVariants = f_products
      .map((itemProduct) =>
        itemProduct.variants.map((itemVariant) => {
          const { product_name } = itemProduct as Record<string, unknown>;
          return { ...itemVariant, product_name };
        }),
      )
      .flat();

    // Transform products
    const t_products: ProductOrder[] = transform(f_products);

    // Transform products inner variants
    const t_productsVariants: ProductOrder[] = transform(productsVariants);

    // Transform variants
    const t_variants: ProductOrder[] = transform(f_variants);

    // Concatenate variants, product variants and products
    const concatenatedTransformedLists: ProductOrder[] = [
      ...t_products,
      ...t_productsVariants,
      ...t_variants,
    ];

    return concatenatedTransformedLists;
  } catch (error) {
    console.error(
      'Error occurred attempting to transform variants and products',
      error,
    );
    return [];
  }
};

export default transformVariantsAndProducts;
